(function ($, westcon) {
    'use strict';

    /**
     * Loader
     * @returns {{init: Function}}
     * @constructor
     */
    var Loader = function () {
        /**
         * All views available on the page.
         * @type {Array}
         */
        var viewsInstances = [];

        /**
         * Initializer
         */
        var init = function () {
            // Load foundation
            $(document).foundation();

            // Get all components on the page
            var components = $('.component');

            // For each component, instantiate the appropriate object and store it in viewsInstances
            _.each(components, function (component) {
                // Look for a custom view, model, and collection
                var view = $(component).attr('data-view');
                var model = $(component).attr('data-model');
                var collection = $(component).attr('data-collection');

                // Throw an Error if the view doesn't exist
                if (westcon.views[view] !== undefined) {
                    var opts = {
                        el: $(component)
                    };

                    // Load either a collection or a model for the view
                    if (collection !== undefined) {
                        // Check to make sure the collection has been defined
                        if (westcon.collections[collection] !== undefined) {
                            opts.collection = new westcon.collections[collection]();
                        }
                    } else {
                        // Check to make sure the model has been defined
                        if (westcon.models[model] !== undefined) {
                            opts.model = new westcon.models[model]();
                        }
                    }

                    // Add the view to the view instances
                    var viewInstance = new westcon.views[view](opts);
                    viewsInstances.push(viewInstance);
                } else {
                    console.log('No view!', $(component));
                    throw new Error('No view found for ' + view);
                }
            });
        };

        // Public
        return {
            init: init,
            viewInstances: viewsInstances
        };
    };

    // Starting the application
    $(document).ready(function () {
        if (!window.loader) {
            window.loader = new Loader();
            window.loader.init();
        }
    });

    //Check IE version & run placeholder script
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => run placeholder jquery
        $('input,textarea').placeholder();
    }
})(jQuery, westcon);
